/* cSpell:disable */
import React from 'react';
// import { TranslationProps } from '../../../i18n/types/translationProps';
import ErrorTemplateImage from './errorTemplateImage';
import './errorTemplate.less';
import './content/Styles/Custom/styles.less';
import './content/Styles/Custom/Widgets/iTSector_Widget_HighlightCard.less';
// import { WithCoreProps } from '@hocs';
import { WithCoreProps, TranslationProps } from 'ff-shared-components-core';

export interface ErrorTemplateProps {
	errorMessage?: string;
	errorTitle?: string;
	buttonText?: string;
}

export type ErrorTemplateInjectedProps = TranslationProps;

class ErrorTemplateScreenComponent extends React.Component<ErrorTemplateProps & ErrorTemplateInjectedProps> {
	render(): React.ReactNode {
		const { t, errorMessage, errorTitle, buttonText } = this.props;

		const title = errorTitle ? errorTitle : '404 Error.';
		const message = errorMessage ? errorMessage : 'Não conseguimos encontrar a página que procura.';
		const btnText = buttonText ? buttonText : 'Início';

		return (
			<div className="page-error">
				<div className="widget-container">
					<div className="clearfix"></div>
					<div
						id="widget-16108"
						className="widget is-visible"
						data-widget="iTSector_Widget_HighlightCard"
						data-id="16108"
					>
						<div id="">
							<div className="container-fluid">
								<div className="inner-container">
									<div className="card-deck Widget_HighlightCard">
										<div className="card">
											<ErrorTemplateImage />
											<div className="card-header">
												<div>{title}</div>
											</div>
											<div className="card-body error-body">
												<div>{message}</div>

												<a className="btn btn-primary-green" href="/" target="">
													{btnText}
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

// const mapStateToProps = (state: StoreState): object => ({
// 	auth: getAuthStateInfo(state),
// });
// const mapDispatchToProps = (dispatch: any): object => bindActionCreators({ fetchLogInRequest }, dispatch);

// export const ErrorTemplateScreen = connect(mapStateToProps, mapDispatchToProps)(ErrorTemplateScreenComponent);
export const ErrorTemplateScreen = WithCoreProps<ErrorTemplateProps>(ErrorTemplateScreenComponent);
